import React, { Component } from "react";
import { translations } from "../../containers/assets/translations";
import { Col, Table, Button } from "react-bootstrap";
import moment from "moment";

export default class BGRListView extends Component {
  // Helper function to render action buttons based on status and permissions
  renderActions(list) {
    const {
      onEdit,
      onSubmit,
      onUnsubmit,
      onCloseReject,
      userPermissions = {},
    } = this.props;

    const { lang = "EN" } = this.props;
    const t = translations[lang] || translations["EN"];
    const status = list.reservationStatus;
    const bgrReservationNumber = list.reservationNumber;

    const canEdit = userPermissions.canEdit;
    const canEditOneMoreTime = userPermissions.canEditOneMoreTime;
    const canSubmit = userPermissions.canSubmit;
    const canUnsubmit = userPermissions.canUnsubmit;
    const canClose = userPermissions.canClose;
    const canReject = userPermissions.canReject;

    // --- Button Logic based on Status ---
    const buttons = [];

    // Always allow viewing details
    buttons.push(
      <span
        key="view"
        onClick={() => this.props.onView(list)}
        style={{ margin: "5px", cursor: "pointer" }}
      >
        {t["View"]}
      </span>
    );

    // EDIT: Available if 'CREATED' (Modify) or 'SUBMITTED' (Edit More One Time)
    if (status === "CREATED" && canEdit) {
      buttons.push(
        <span
          key="edit"
          onClick={() => onEdit(list)}
          style={{ margin: "5px", cursor: "pointer" }}
        >
          {t["Edit"]}
        </span>
      );
    } else if (
      status === "SUBMITTED" &&
      canEditOneMoreTime &&
      list.moreOneTime === "true"
    ) {
      buttons.push(
        <span
          key="edit-once"
          onClick={() => onEdit(list)}
          style={{ margin: "5px", cursor: "pointer" }}
        >
          {t["Edit (1 Time)"]}
        </span>
      );
    }

    // SUBMIT: Available if 'CREATED'
    if (status === "CREATED" && canSubmit) {
      buttons.push(
        <span
          key="submit"
          onClick={() => onSubmit(bgrReservationNumber)}
          style={{ margin: "5px", cursor: "pointer" }}
        >
          {t["Submit"]}
        </span>
      );
    }

    // UNSUBMIT: Available if 'SUBMITTED'
    if (status === "SUBMITTED" && canUnsubmit) {
      buttons.push(
        <span
          key="unsubmit"
          onClick={() => onUnsubmit(bgrReservationNumber)}
          style={{ margin: "5px", cursor: "pointer" }}
        >
          {t["Unsubmit"]}
        </span>
      );
    }

    // CLOSE/REJECT: Available if 'SUBMITTED'
    if (status === "SUBMITTED") {
      if (canClose) {
        buttons.push(
          <span
            key="close"
            onClick={() => onCloseReject(bgrReservationNumber, "CLOSED")}
            style={{ margin: "5px", cursor: "pointer" }}
          >
            {t["Close"]}
          </span>
        );
      }
      if (canReject) {
        buttons.push(
          <span
            key="reject"
            onClick={() => onCloseReject(bgrReservationNumber, "REJECTED")}
            style={{ margin: "5px", cursor: "pointer" }}
          >
            {t["Reject"]}
          </span>
        );
      }
    }

    // EXPORT (Assuming it's always available if the list is visible and has data)
    // buttons.push(
    //   <span
    //     key="export"
    //     onClick={() => this.props.onExport(bgrReservationNumber)}
    //     style={{ cursor: "pointer" }}
    //   >
    //     {t["Export"]}
    //   </span>
    // );

    return <div className="bgr-action-buttons">{buttons}</div>;
  }

  render() {
    const {
      bgrLists,
      lang = "EN",
      currentPage = 1,
      pageSize = 20,
      totalItems = 0,
      onPageChange,
      loading,
    } = this.props;

    const t = translations[lang] || translations["EN"];

    const totalPages = Math.ceil(totalItems / pageSize);
    const hasNextPage = currentPage < totalPages;
    const hasPrevPage = currentPage > 1;

    if ((!bgrLists && !loading) || (bgrLists.length === 0 && !loading)) {
      return (
        <Col md={12} className="no-results-message">
          <h3 className="text-center">{t["No BGR Lists Found"]}</h3>
        </Col>
      );
    }

    return (
      <Col md={12} className="bgr-list-view-container">
        <div className="table-responsive">
          <Table striped bordered condensed hover>
            <thead>
              <tr>
                <th>{t["Reservation ID"]}</th>
                <th>{t["Creation Date"]}</th>
                <th>{t["License Plate"]}</th>
                <th>{t["Transport Company"]}</th>
                <th>{t["Status"]}</th>
                <th style={{ width: "400px" }}>{t["Actions"]}</th>
              </tr>
            </thead>
            <tbody>
              {bgrLists.map((list, index) => (
                <tr key={list.reservationId + index}>
                  <td>{list.reservationId}</td>
                  <td>
                    {moment(list.creationTime).format("MM-DD-YYYY HH:mm")}
                  </td>
                  <td>{list.licensePlate}</td>
                  <td>{list.transportCompany}</td>
                  <td>{list.reservationStatus}</td>
                  <td>{this.renderActions(list)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div
          className="pagination-wrapper"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "15px",
          }}
        >
          <Button
            disabled={!hasPrevPage}
            onClick={() => onPageChange(currentPage - 1)}
            bsSize="small"
          >
            {t["Previous"]}
          </Button>

          <div style={{ margin: "0 15px", fontWeight: "bold" }}>
            {t["Page"]} {currentPage} {t["of"]} {totalPages || 1}
          </div>

          <Button
            disabled={!hasNextPage}
            onClick={() => onPageChange(currentPage + 1)}
            bsSize="small"
          >
            {t["Next"]}
          </Button>
        </div>
        {/* <div
          className="text-center"
          style={{ fontSize: "12px", color: "#666", marginTop: "5px" }}
        >
          {t["Total Records"]}: {totalItems}
        </div> */}
      </Col>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/bgrComponents/BGRListView.js